import { generateGuid } from '@bingads-webui-universal/primitive-utilities';

export function getDefaultUrl(serverContext) {
  const { CampaignAPI } = serverContext.ServicesEndpoints;

  return `${CampaignAPI}mmp/`;
}

export function getDefaultOptions(serverContext) {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      lcid: serverContext.CurrentUser.Locale,
      'x-ms-clientapplication': 'bingadsweb', // required, will get 401 if missing
      'x-ms-pagetrackingid': serverContext.PageTrackingId,
      Authorization: `CCMTSmallToken ${serverContext.Token}`,
    },
    cachePolicy: 'no-cache',
    interceptors: {
      request: ({ options }) => {
        // eslint-disable-next-line no-param-reassign
        options.headers['x-ms-requestid'] = generateGuid();

        return options;
      },
    },
  };

  return defaultOptions;
}
